import * as React from 'react';

export class PartpayBanner extends React.Component {
    public render() {
        return (
            <div className="partpay-banner">
                <div className="first-line">Buy Now, pay later.
                    
                </div>
                <div className="second-line">With 4x interest free payments by
                    <img className="partpay-logo" src="https://s3-ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/EveWellness/Icons/Afterpay_Logo_White.svg" alt="afterpay" />
                </div>
            </div>
        );
    }
}
